<template>
  <footer id="footer" class="footer">
    <div class="footer-inner">
      <div class="footer-brand">
        <img class="logo" src="/logo.png" alt="Logo" />
      </div>
      <div class="link-group">
        <h4>{{ $t('footer.quickLinks') }}</h4>
        <a href="javascript:void(0)" @click="goHome()">{{ $t('footer.home') }}</a>
        <a href="javascript:void(0)" @click="goHash('/#what')">{{ $t('footer.aboutCepa') }}</a>
        <a href="javascript:void(0)" @click="goAssessment()">{{ $t('footer.startTest') }}</a>
      </div>
      <div class="link-group">
<!--        <h4>{{ $t('footer.support') }}</h4>-->
<!--        <a href="javascript:void(0)" @click="go('/contact')">{{ $t('footer.contact') }}</a>-->
<!--        <a href="javascript:void(0)" @click="go('/policy')">{{ $t('footer.servicePolicy') }}</a>-->
<!--        <a href="javascript:void(0)" @click="goHash('/#faq')">{{ $t('footer.faq') }}</a>-->
      </div>
    </div>
    <div class="footer-bottom">
<!--      <p>{{ $t('footer.copyright') }}</p>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  methods: {
    go(path) {
      if (this.$route.path !== path) {
        this.$router.push(path)
      }
    },
    goHome() {
      if (this.$route.path !== '/') {
        this.$router.push('/')
      } else {
        window.scrollTo({ top: 0, behavior: 'smooth' })
      }
    },
    goHash(hash) {
      // If not on home page, navigate there first then scroll
      if (this.$route.path !== '/') {
        this.$router.push(hash)
      } else {
        var id = hash.replace('/#', '')
        var el = document.getElementById(id)
        if (el) el.scrollIntoView({ behavior: 'smooth' })
      }
    },
    goAssessment() {
      var token = localStorage.getItem('token')
      if (token) {
        this.$router.push('/assessment')
      } else {
        this.$router.push('/login')
      }
    }
  }
}
</script>

<style scoped>
.footer { background: #1a1a2e; color: #aaa; padding: 40px 40px 0; font-size: 13px; }
.footer-inner { display: flex; justify-content: space-between; max-width: 1100px; margin: 0 auto; padding-bottom: 32px; }
.brand-name { font-size: 28px; font-weight: 800; color: #fff; }
.link-group h4 { color: #fff; font-size: 14px; font-weight: 600; margin-bottom: 14px; }
.link-group a { display: block; color: #aaa; text-decoration: none; margin-bottom: 8px; font-size: 13px; transition: color 0.2s; cursor: pointer; }
.link-group a:hover { color: #fff; }
.footer-bottom { border-top: 1px solid rgba(255,255,255,0.1); text-align: center; padding: 16px 0; font-size: 12px; color: #666; }
@media (max-width: 768px) { .footer-inner { flex-direction: column; gap: 24px; } .footer { padding: 32px 20px 0; } }
.logo {
  height: 100px;
  width: auto;
  object-fit: contain;
}
</style>
